import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { isMplPreApprovalOffer } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

import { OfferControlsTexts } from '../OfferControls.texts';

export const getOfferButtonText = (offer: TOffer | MPLPreApprovalOffer) => {
  if (isMplPreApprovalOffer(offer)) {
    return OfferControlsTexts.sendMplOfferLabel;
  }

  return offer?.additionalInfo?.buttonText || OfferControlsTexts.sendOfferLabel;
};
